export enum CabinetConfigurationLevel {
  Cabinet,
  DocumentType
}
